import React from 'react';
import { Form as RSForm } from 'rsuite5';
import FormControl, { FormikControlProps } from './FormControl';
import { FORM_DEFAULT_DISPLAY } from '@/constants/config';
import Help from '../shared/Help';
import SelectPicker from './SelectPicker';
import RequiredTxt from '@/components/shared/RequiredTxt';
import Input from './Input';
import classes from 'classnames';

export interface FormFieldProps extends FormikControlProps {
  label: string;
  labelInfo?: React.ReactNode;
  labelStyle?: React.CSSProperties;
  /** 是否可选 */
  optional?: boolean;
  helpText?: React.ReactNode;
  /** 格式化文本显示 */
  fmtLabel?: (val) => void;
  inline?: boolean;
}
function FormField({
  label,
  helpText,
  name,
  optional,
  labelInfo,
  accepter = Input,
  fmtLabel,
  required,
  inline,
  style,
  labelStyle,
  className,
  ...props
}: FormFieldProps): JSX.Element {
  //如果接收的SelectPicker这里统一处理显示 这里用==，是因为后端返回的是字符串

  const selectFmtLabel =
    accepter === SelectPicker
      ? (val) => props?.data?.find((i) => i.value == val)?.label
      : undefined;

  return (
    <RSForm.Group className={classes(inline && 'formik-group-inline', className)} style={style}>
      <RSForm.ControlLabel htmlFor={props.name} style={labelStyle}>
        <span>
          {label}
          {required && !props?.readOnly && <RequiredTxt />}
          {labelInfo && (
            <Help>
              <div>{labelInfo}</div>
            </Help>
          )}
        </span>
        {optional && <span className="form-optional-label">选填</span>}
      </RSForm.ControlLabel>
      <FormControl
        name={name}
        // 这里加个空格，可能组件判断有问题不生效空字符串
        placeholder={props?.readOnly ? FORM_DEFAULT_DISPLAY : ' '}
        fmtLabel={fmtLabel ?? selectFmtLabel}
        nextReadOnly={props?.readOnly}
        accepter={accepter}
        {...props}
      />
      {helpText && <RSForm.HelpText>{helpText}</RSForm.HelpText>}
    </RSForm.Group>
  );
}

export default React.memo(FormField);
